import { openDB } from 'idb'

// Low-level IndexedDB access for the demo. All datasets and uploaded file
// bytes live here (Вопрос 2Б — файлы хранятся целиком, чтобы «скачать» в
// истории отдавал реальный файл). Metadata/settings live in localStorage.

export const DB_NAME = 'bvxtb-demo'
export const DB_VERSION = 1

export const STORES = {
	schoolsStats: 'schoolsStats',
	teachersStats: 'teachersStats',
	uploadHistory: 'uploadHistory',
	departmentDocuments: 'departmentDocuments',
	files: 'files',
}

let dbPromise = null

export const getDB = () => {
	if (!dbPromise) {
		dbPromise = openDB(DB_NAME, DB_VERSION, {
			upgrade(db) {
				// district+period keyed datasets (id = `${districtId}__${period}`)
				if (!db.objectStoreNames.contains(STORES.schoolsStats)) {
					db.createObjectStore(STORES.schoolsStats, { keyPath: 'id' })
				}
				if (!db.objectStoreNames.contains(STORES.teachersStats)) {
					db.createObjectStore(STORES.teachersStats, { keyPath: 'id' })
				}
				// upload history (statistics module)
				if (!db.objectStoreNames.contains(STORES.uploadHistory)) {
					const s = db.createObjectStore(STORES.uploadHistory, { keyPath: 'id' })
					s.createIndex('moduleId', 'moduleId')
				}
				// department documents (depts 1–4)
				if (!db.objectStoreNames.contains(STORES.departmentDocuments)) {
					const s = db.createObjectStore(STORES.departmentDocuments, { keyPath: 'id' })
					s.createIndex('subsectionId', 'subsectionId')
					s.createIndex('departmentId', 'departmentId')
				}
				// raw file bytes: { id, blob, name, type }
				if (!db.objectStoreNames.contains(STORES.files)) {
					db.createObjectStore(STORES.files, { keyPath: 'id' })
				}
			},
		})
	}
	return dbPromise
}

// Delete the whole demo database (used by "clear all data").
export const deleteDB = async () => {
	const db = await getDB()
	db.close()
	dbPromise = null
	await new Promise((resolve, reject) => {
		const req = indexedDB.deleteDatabase(DB_NAME)
		req.onsuccess = () => resolve()
		req.onerror = () => reject(req.error)
		req.onblocked = () => resolve()
	})
}
